/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StageImageResponse,
    StageImageResponseFromJSON,
    StageImageResponseFromJSONTyped,
    StageImageResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface StageResponse
 */
export interface StageResponse {
    /**
     * 
     * @type {number}
     * @memberof StageResponse
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof StageResponse
     */
    next: string;
    /**
     * 
     * @type {string}
     * @memberof StageResponse
     */
    previous: string;
    /**
     * 
     * @type {Array<StageImageResponse>}
     * @memberof StageResponse
     */
    results: Array<StageImageResponse>;
}

export function StageResponseFromJSON(json: any): StageResponse {
    return StageResponseFromJSONTyped(json, false);
}

export function StageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StageResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'],
        'previous': json['previous'],
        'results': ((json['results'] as Array<any>).map(StageImageResponseFromJSON)),
    };
}

export function StageResponseToJSON(value?: StageResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(StageImageResponseToJSON)),
    };
}


